/**
 * ApiClient injection — FW-126 ortak zemin, FW-142 ikinci istemciyle genisletildi.
 *
 * FW-14 `createSurfaceApp` kanonik `ApiClient`'i kurar (bkz. createSurfaceApp.ts)
 * ama hicbir bilesene ULASTIRMIYORDU (olculdu: apps/* icinde `apiClient` adi
 * hic gecmiyor, hicbir yuzey gercek bir API cagrisi yapmiyordu). FW-126 auth
 * akisi bu bosluguyla ilk karsilasan dilim; cozum ortak zemine (bu paket)
 * eklendi ki sonraki dilimler tekrar kesfetmesin.
 *
 * Kullanim: `createSurfaceApp` donen `apiClient`'i Vue'nin provide/inject'iyle
 * uygulama agacina asilar; bilesenler/composable'lar `useApiClient()` ile okur.
 *
 * IKINCI ISTEMCI (FW-142) — OLCULDU GEREKCE: `apps/auth` iki AYRI backend
 * host'una konusur, ayni host'a degil.
 *   - `POST /api/v1/auth/login-by-email`  -> YALNIZ identity-host'ta var
 *     (staging olcumu: id-stg 400 "route var", app-web-api-stg 404 "route YOK").
 *   - `POST /api/v1/auth/login` (BFF cerez akisi) + `GET /api/v1/auth/session`
 *     -> `fw-session` cerezini YAZAN/OKUYAN host web-api'dir: GET session
 *     id-stg'de 404 (route YOK), app-web-api-stg'de 401 (route VAR, kimlik
 *     dogrulama gerektiriyor) — bu FW-142'nin kendi olcumu, tahmin degil.
 *     Cerez host-only oldugu icin (bkz. MIMARI.md "Neden bu ayrim cerezi
 *     kirmiyor") login'in yazdigi cerez SADECE onu yazan host'a doner; login
 *     ve session bu yuzden AYNI istemciyi (web api) paylasmak ZORUNDA.
 * Bu yuzden ayri bir `IDENTITY_API_CLIENT_KEY` + `useIdentityApiClient()`
 * eklendi: `useLoginByEmail` bunu kullanir, `useLogin`/`useSession` mevcut
 * `useApiClient()` (web api) ile devam eder.
 */
import { inject, type InjectionKey } from 'vue'
import type { ApiClient } from '@fusapp-work/api'

export const API_CLIENT_KEY: InjectionKey<ApiClient> = Symbol('fusapp-work-api-client')
export const IDENTITY_API_CLIENT_KEY: InjectionKey<ApiClient> = Symbol('fusapp-work-identity-api-client')

export function useApiClient(): ApiClient {
  const client = inject(API_CLIENT_KEY)
  if (!client) {
    throw new Error(
      'useApiClient() cagrildi ama ApiClient saglanmamis — createSurfaceApp disinda mi kullanildi?',
    )
  }
  return client
}

export function useIdentityApiClient(): ApiClient {
  const client = inject(IDENTITY_API_CLIENT_KEY)
  if (!client) {
    throw new Error(
      'useIdentityApiClient() cagrildi ama identity ApiClient saglanmamis — createSurfaceApp' +
        " 'identityApiClientOptions' olmadan mi kuruldu?",
    )
  }
  return client
}
